import xlsx, { IContent } from 'json-as-xlsx';
import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { AggregatedFrame } from './FramesReport/FramesReport.types';
import { FRAME_REPORT_COLUMNS, FrameReportColumn, getExportValue } from './FramesReport/columns';
import { generateFramesReportFileName } from './utils';

type UseExportFramesReport = {
  handleExportFramesReport: () => void;
};

export const useExportFramesReport = ({
  rowData,
  columns = FRAME_REPORT_COLUMNS,
}: {
  rowData: AggregatedFrame[];
  columns?: FrameReportColumn[];
}): UseExportFramesReport => {
  const dealName = useSelector((state: Store) => state.dealManagement.commonDeal.dealName);

  const handleExportFramesReport = (): void => {
    if (!rowData?.length) return;

    const fileName = generateFramesReportFileName({ campaignName: dealName });

    const exportColumns = columns.map((col) => ({ label: col.label, value: col.field }));

    const content: IContent[] = rowData.map((row) =>
      Object.fromEntries(columns.map((col) => [col.field, getExportValue(row, col)])),
    );

    xlsx(
      [
        {
          sheet: 'Frame List',
          columns: exportColumns,
          content,
        },
      ],
      {
        fileName,
      },
    );
  };

  return {
    handleExportFramesReport,
  };
};
